module.exports = __webpack_public_path__ + "img/TVdenwa.439b6fee.png";